<template>
    <emc-card-stats
        color="blue lighten-1"
        icon="mdi-speedometer-medium"
        icon-large
        :title="title"
        :value="value"
        :show-actions="showActions"
        :text-actions="title"
        :sub-text="showActions ? null : 'CH Média Docente'"
    >
        <template  v-slot:actions>
            <v-tooltip bottom v-if="showMoreButton">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" color="primary" v-on="on" icon @click="$emit('showMoreWorkLoadAvg')">
                        <v-icon btn>mdi-monitor-eye</v-icon>
                    </v-btn>
                </template>
                <span>
                    Ver Mais...
                </span>
            </v-tooltip>

            <emc-button-icon v-if="!hideRefresh" btn-small :disabled="isBusy" icon="mdi-refresh-circle" :text="updated_at || `Atualizar`" color="success" @click.prevent.stop="start()" />
        </template>

        <template v-slot:tools>
            <emc-chart-refresh-status v-if="!hideRefresh" :label="statusLabel" :failed="hasFailed" :error-code="errorCode" />
        </template>

        </emc-card-stats>
</template>

<script>

import { getCurrentInstance } from 'vue'
import { mapActions } from 'vuex'
import { useChartRefresh } from '@/composables/useChartRefresh'

export default {
    name: 'EmcChartTeacherWorkLoadAvg',
    setup() {
        const { proxy } = getCurrentInstance()

        return useChartRefresh({
            refreshAction: 'chart/ActionTeacherWorkLoadAvgRefresh',
            onFinished: () => proxy.getData()
        })
    },
    data () {
        return {
            value: '0',
            title: '',
            updated_at: null
        }
    },
    props: {
        showMoreButton: {
            type: Boolean,
            default: false
        },
        item: { },
        noLoad: {
            type: Boolean,
            default: false,
        },
        showActions: {
            type: Boolean,
            default: false,
        },
        hideRefresh: {
            type: Boolean,
            default: false,
        }
    },
    
    methods: {
        ...mapActions('chart', ['ActionChartTeacherWorkLoadAvg']),
        async getData() {

            if(this.noLoad){
                this.value = this.item.value;
                this.title = this.item.title;
                return;
            }

            await this.ActionChartTeacherWorkLoadAvg()
                .then((r) => {
                    this.value = r.data.value.toString()
                    this.title = r.data.title
                    this.updated_at = r.data.updated_at

                    // Recarga já em andamento (normalmente a carga noturna):
                    // o card mostra o andamento sem o usuário ter clicado.
                    this.adopt(r.data.refresh)
                })
        }
    },
    created(){
        this.getData()
    }

    
}
</script>